import {Map} from 'immutable';
import LabModeTypes from '~/constants/types/LabModeTypes';
import {DEFAULT_MODE, FUNDRAISING_MODE} from '~/constants/LabModes';

export function initialState() {
  return Map({
    mode: DEFAULT_MODE
  });
}

export default function labMode(state = initialState(), action) {
  switch (action.type) {
    case LabModeTypes.UPDATE_LAB_MODE: {
      switch (action.payload) {
        case FUNDRAISING_MODE:
          return state.set('mode', FUNDRAISING_MODE);
        case DEFAULT_MODE:
          return state.set('mode', DEFAULT_MODE);
        default:
          return state;
      }
    }
    default:
      return state;
  }
}
